import { CategoryType } from 'component/Accommodation/Category/type';
import { ACCustomClass } from 'component/Layout/Autocomplete/types';

import { DestinationValue, FlightDistance } from 'types/Search/form';

export enum AutocompleterGroupType {
    Destination = 'destination',
    Hotel = 'hotel',
}

export enum DestinationType {
    Hotel = 'hotel',
    City = 'city',
    CtsDestination = 'cts_destination',
    Region = 'region',
    RegionGroup = 'region_group', // unknown by old autocompleter, must be determined by regionId
    Country = 'country',
}

export interface SearchProps {
    customClassList?: ACCustomClass;
    destinationValue: DestinationValue;
    onValueChange: (value: DestinationValue) => void;
    onEmptyDestinationClick?: () => void;
    placeholder?: string;
    label?: string;
}

interface BaseGroupType {
    resolve: boolean;
    trackingId: string;
    type: DestinationType;
    id: number;
    imageUrl: string;
    label: string;
    link: string;
    pos: number;
    group: AutocompleterGroupType;
    highlightedLabel: string;
    combinedLabel: string;
    xPos?: number;
}

export interface HotelGroupType extends BaseGroupType {
    type: DestinationType.Hotel;
    group: AutocompleterGroupType.Hotel;
    city: number;
    cityName: string;
    countryCode: string;
    countryId: number;
    countryName: string;
    hotelCategoryStars: number;
    hotelCategoryType: CategoryType;
    regionGroupId: number;
    regionName: string;
    regions: number[];
    destinationLabel: string;
    destinationTree: string;
    destinationTreePrefix: string;
}

export interface CountryGroupType extends BaseGroupType {
    type: DestinationType.Country;
    group: AutocompleterGroupType.Destination;
    regions: number[];
    countryCode: string;
    destinationTree: string;
    destinationTreePrefix: string;
    hotelCount: number;
}

export interface RegionGroupType extends BaseGroupType {
    type: DestinationType.Region | DestinationType.RegionGroup;
    group: AutocompleterGroupType.Destination;
    regions: number[];
    isRegionGroup: boolean;
    regionGroupId: number;
    destinationTree: string;
    destinationTreePrefix: string;
    regionHotelCount: number;
}

export interface CityGroupType extends BaseGroupType {
    type: DestinationType.City;
    group: AutocompleterGroupType.Destination;
    regions: number[];
    regionName: string;
    countryName: string;
    countryCode: string;
    countryId: number;
    recentAvgBookingValue: number;
    recentBookingCount: number;
    recentFourStarBookingCount: number;
    recentHolidayType: string; // later as enum
    recentHotelCount: number;
    regionGroupId: number;
    airportCode: string;
    destinationTree: string;
    destinationTreePrefix: string;
    destinationLabel: string;
    hotelCount: number;
}

export interface CtsDestinationGroupType extends BaseGroupType {
    type: DestinationType.CtsDestination;
    group: AutocompleterGroupType.Destination;
    destinationTree: string;
    destinationTreePrefix: string;
    hotelCount: number;
}

export type AutocompleterGroupDestination = {
    data: (
        | CountryGroupType
        | RegionGroupType
        | CityGroupType
        | CtsDestinationGroupType
    )[];
    group: AutocompleterGroupType.Destination;
    label: string;
};

export type AutocompleterGroupHotel = {
    data: HotelGroupType[];
    group: AutocompleterGroupType.Hotel;
    label: string;
};

export type DestinationEntry =
    | CountryGroupType
    | RegionGroupType
    | CityGroupType
    | CtsDestinationGroupType
    | HotelGroupType;

export type AutocompleterGroup =
    | AutocompleterGroupDestination
    | AutocompleterGroupHotel;

export type TopRegion = {
    name: string;
    countryName: string;
    groupId: number;
    regionId: number;
    flightTime: number;
    imageUrl: string;
    xPos?: number;
};

export interface DestinationAcRequest {
    /** version */
    v: string;
    /** searchTerm */
    term: string;
}

export interface DestinationAcResponse {
    data: AutocompleterGroup[];
    httpstatuscode: number;
    statusmessage: string;
}

export interface TargetDistance {
    name: string;
    lvl: number;
    type: string;
    value: FlightDistance;
    expand: string;
}
